import angular from 'angular';
import uiRouter from 'angular-ui-router';

import MenuSettingsComponent from './settings.component';

const menuSettingsModule = angular.module('tinaba.components.menu.settings', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject';
  $stateProvider.state('menu.settings', {
    url: '/settings',
    template: '<menu-settings></menu-settings>'
  });
})

.component('menuSettings', MenuSettingsComponent);

export default menuSettingsModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/settings/settings.js
 **/